<template>
  <div class="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
    <div class="max-w-md w-full space-y-8">
      <!-- Logo -->
      <div class="text-center">
        <router-link to="/" class="text-2xl font-bold text-gray-900"> ASAB </router-link>
      </div>

      <!-- Main content -->
      <router-view />

      <!-- Back to home link -->
      <div class="text-center">
        <router-link to="/" class="text-sm text-blue-600 hover:text-blue-500">
          ← Back to home
        </router-link>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  //
</script>
